<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addScholarshipType()" *ngIf="status">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search for Scholarship Type"
            [formControl]="control"
            [appAutocomplete]="autocomplete"
          />
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="
                  (scholarshipCategories | filter: control.value) as result
                "
              >
                <app-option
                  (click)="selectScholarshipType(option.id)"
                  *ngFor="let option of result"
                  [value]="option.ScholarshipCategoryName"
                >
                  {{ option.ScholarshipCategoryName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="custom_table_three_row" *ngIf="status">
      <form [formGroup]="scholarshipTypeForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Scholarship Type Name</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="ScholarshipTypes">
          <div
            class="td"
            *ngFor="
              let scholarshipeType of scholarshipTypeForm.get(
                'ScholarshipTypes'
              )['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="ScholarshipTypeName"
                placeholder="Enter Scholarship type"
            /></span>
            <span
              ><button
                class="delete_icon trash"
                (click)="deleteScholarshipType(i, scholarshipeType.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>

        <div class="submit">
          <button
            class="submit_button"
            (click)="onSubmit(scholarshipTypeForm.value)"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
